import * as styles from "./styles.css";

export interface SocialMediaIconsProps {
  socialMedia: string;
}

const InstagramIcon = () => (
  <svg
    className={styles.icon}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16.0268 9.8125C19.4018 9.8125 22.1875 12.5982 22.1875 15.9732C22.1875 19.4018 19.4018 22.1339 16.0268 22.1339C12.5982 22.1339 9.86607 19.4018 9.86607 15.9732C9.86607 12.5982 12.5982 9.8125 16.0268 9.8125ZM16.0268 19.9911C18.2232 19.9911 19.9911 18.2232 19.9911 15.9732C19.9911 13.7768 18.2232 12.0089 16.0268 12.0089C13.7768 12.0089 12.0089 13.7768 12.0089 15.9732C12.0089 18.2232 13.8304 19.9911 16.0268 19.9911ZM23.8482 9.59821C23.8482 8.79464 23.2054 8.15179 22.4018 8.15179C21.5982 8.15179 20.9554 8.79464 20.9554 9.59821C20.9554 10.4018 21.5982 11.0446 22.4018 11.0446C23.2054 11.0446 23.8482 10.4018 23.8482 9.59821ZM27.9196 11.0446C28.0268 13.0268 28.0268 18.9732 27.9196 20.9554C27.8125 22.8839 27.3839 24.5446 25.9911 25.9911C24.5982 27.3839 22.8839 27.8125 20.9554 27.9196C18.9732 28.0268 13.0268 28.0268 11.0446 27.9196C9.11607 27.8125 7.45536 27.3839 6.00893 25.9911C4.61607 24.5446 4.1875 22.8839 4.08036 20.9554C3.97321 18.9732 3.97321 13.0268 4.08036 11.0446C4.1875 9.11607 4.61607 7.40179 6.00893 6.00893C7.45536 4.61607 9.11607 4.1875 11.0446 4.08036C13.0268 3.97321 18.9732 3.97321 20.9554 4.08036C22.8839 4.1875 24.5982 4.61607 25.9911 6.00893C27.3839 7.40179 27.8125 9.11607 27.9196 11.0446ZM25.3482 23.0446C25.9911 21.4911 25.8304 17.7411 25.8304 15.9732C25.8304 14.2589 25.9911 10.5089 25.3482 8.90179C24.9196 7.88393 24.1161 7.02679 23.0982 6.65179C21.4911 6.00893 17.7411 6.16964 16.0268 6.16964C14.2589 6.16964 10.5089 6.00893 8.95536 6.65179C7.88393 7.08036 7.08036 7.88393 6.65179 8.90179C6.00893 10.5089 6.16964 14.2589 6.16964 15.9732C6.16964 17.7411 6.00893 21.4911 6.65179 23.0446C7.08036 24.1161 7.88393 24.9196 8.95536 25.3482C10.5089 25.9911 14.2589 25.8304 16.0268 25.8304C17.7411 25.8304 21.4911 25.9911 23.0982 25.3482C24.1161 24.9196 24.9732 24.1161 25.3482 23.0446Z" />
  </svg>
);

const LinkedInIcon = () => (
  <svg
    className={styles.icon}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.6875 21H0.328125V6.98438H4.6875V21ZM2.48438 5.10938C1.125 5.10938 0 3.9375 0 2.53125C0 1.17188 1.125 0.046875 2.48438 0.046875C3.89062 0.046875 5.01562 1.17188 5.01562 2.53125C5.01562 3.9375 3.89062 5.10938 2.48438 5.10938ZM20.9531 21H16.6406V14.2031C16.6406 12.5625 16.5938 10.5 14.3438 10.5C12.0938 10.5 11.7656 12.2344 11.7656 14.0625V21H7.40625V6.98438H11.5781V8.90625H11.625C12.2344 7.82812 13.6406 6.65625 15.75 6.65625C20.1562 6.65625 21 9.5625 21 13.3125V21H20.9531Z" />
  </svg>
);

const FacebookIcon = () => (
  <svg
    className={styles.icon}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M20.6351 17.3333H17.7261V26.6667H13.8473V17.3333H10.6667V13.5H13.8473V10.5417C13.8473 7.20833 15.7091 5.33333 18.5406 5.33333C19.8982 5.33333 21.3333 5.625 21.3333 5.625V8.91667H19.743C18.1915 8.91667 17.7261 9.91667 17.7261 11V13.5H21.1782L20.6351 17.3333Z" />
  </svg>
);

const YoutubeIcon = () => (
  <svg
    className={styles.icon}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M27.4735 10.6764C28 12.5192 28 16.468 28 16.468C28 16.468 28 20.3729 27.4735 22.2596C27.2102 23.3126 26.3766 24.1024 25.3675 24.3656C23.4808 24.8483 16.0219 24.8483 16.0219 24.8483C16.0219 24.8483 8.5192 24.8483 6.63254 24.3656C5.6234 24.1024 4.78976 23.3126 4.52651 22.2596C4 20.3729 4 16.468 4 16.468C4 16.468 4 12.5192 4.52651 10.6764C4.78976 9.6234 5.6234 8.78976 6.63254 8.52651C8.5192 8 16.0219 8 16.0219 8C16.0219 8 23.4808 8 25.3675 8.52651C26.3766 8.78976 27.2102 9.6234 27.4735 10.6764ZM13.5649 20.0219L19.7952 16.468L13.5649 12.9141V20.0219Z" />
  </svg>
);

const TwitterIcon = () => (
  <svg
    className={styles.icon}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22.8996 5H26.5815L18.5398 14.189L28 26.6949H20.5945L14.7901 19.1121L8.15647 26.6949H4.46938L13.0691 16.8644L4.00002 5H11.5932L16.8344 11.9309L22.8996 5ZM21.6063 24.4941H23.6454L10.4824 7.08605H8.29206L21.6063 24.4941Z" />
  </svg>
);

const TiktokIcon = () => (
  <svg
    className={styles.icon}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M26.9699 13.8297C24.8636 13.8765 22.8977 13.2212 21.2126 12.0042V20.3828C21.2126 26.2338 14.8467 29.8848 9.79144 26.9827C4.73619 24.0338 4.73619 16.7318 9.79144 13.7829C11.2425 12.9403 12.9744 12.6127 14.6595 12.8467V17.0594C12.085 16.2169 9.60421 18.5105 10.1659 21.1317C10.7744 23.7529 13.9573 24.7827 15.9701 22.9572C16.6722 22.3019 17.0935 21.3657 17.0935 20.3828V4H21.2126C21.2126 4.37446 21.2126 4.70212 21.3062 5.07658C21.587 6.62124 22.4764 7.97867 23.8338 8.82122C24.7232 9.42972 25.8466 9.75737 26.9699 9.75737V13.8297Z" />
  </svg>
);

const MailIcon = () => (
  <svg
    className={styles.icon}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.25 7.22425V14.375C1.25 15.7557 2.36929 16.875 3.75 16.875H16.25C17.6307 16.875 18.75 15.7557 18.75 14.375V7.22425L11.3102 11.8026C10.5067 12.297 9.49327 12.297 8.68976 11.8026L1.25 7.22425Z"
      fill="inherit"
    />
    <path
      d="M18.75 5.75652V5.625C18.75 4.24429 17.6307 3.125 16.25 3.125H3.75C2.36929 3.125 1.25 4.24429 1.25 5.625V5.75652L9.34488 10.738C9.74664 10.9852 10.2534 10.9852 10.6551 10.738L18.75 5.75652Z"
      fill="inherit"
    />
  </svg>
);

export default function SocialMediaIcons({
  socialMedia,
}: SocialMediaIconsProps) {
  const renderIcon = () => {
    switch (socialMedia) {
      case "instagram":
        return <InstagramIcon />;
      case "linkedin":
        return <LinkedInIcon />;
      case "facebook":
        return <FacebookIcon />;
      case "youtube":
        return <YoutubeIcon />;
      case "twitter":
        return <TwitterIcon />;
      case "tiktok":
        return <TiktokIcon />;
      case "email":
        return <MailIcon />;
      default:
        return null;
    }
  };

  return <div className={styles.iconContainer}>{renderIcon()}</div>;
}
